export const WORKSPACE_AGENT_MENTION_SEARCH_DEBOUNCE_MS = 300;

/**
 * How long a collapsed expandable row must stay highlighted before its first children page is
 * fetched. Matches the panel hover-card delay so expand is ready once the pointer has committed.
 */
export const WORKSPACE_AGENT_MENTION_CHILD_PREFETCH_DELAY_MS = 150;

export const WORKSPACE_AGENT_MENTION_PAGE_SIZE = 30;

/** Shared `Boards.list` fields for each expanded node in the browse tree. */
export const WORKSPACE_AGENT_BOARD_LIST_OPTIONS = {
  includeCoverImage: true,
  // Without it the response omits the count the chevrons are drawn from.
  includeDirectDescendantBoardCount: true,
  isMemberOfBoard: 'ALL',
  limit: WORKSPACE_AGENT_MENTION_PAGE_SIZE,
} as const;

export const WORKSPACE_AGENT_MENTION_CHAR = '@';

/** Escape hands focus back to the composer; a pointer press outside or a Tab out must not dismiss via Escape semantics alone. */
export type WorkspaceAgentMentionDismissReason = 'escape' | 'pointer-outside' | 'tab';

/**
 * Set as `aria-controls` on the composer's contenteditable, not on the popup. Role-neutral: the
 * node it names is a `tree` on the boards source and a `listbox` on every flat one.
 */
export const WORKSPACE_AGENT_MENTION_LIST_ID = 'workspace-agent-mention-list';

/** Marks the portaled Contexts kit dropdown so outside-press logic can ignore it (not a test id). */
export const WORKSPACE_AGENT_MENTION_CONTEXTS_KIT_MENU_ATTRIBUTE = 'data-workspace-agent-mention-contexts-kit-menu';

/**
 * Transaction meta the `@` button sets to hand a dismissed `@` back to the picker. The only way a
 * transaction that leaves the document alone can reopen one — see `shouldResetDismissed`.
 */
export const WORKSPACE_AGENT_MENTION_REOPEN_META = 'workspaceAgentMentionReopen';
